<template>
  <section id="osd-benefits">
    <v-container>
      <v-row align="center" justify="center">
        <v-col cols="12" md="10">
          <v-row align="center" justify="center">
            <!-- Imagen representativa -->
            <!-- <v-col cols="12" md="4" class="mb-4 mb-md-0">
              <v-img
                src="@/assets/img/sujeto.png"
                class="d-block ml-auto mr-auto"
                max-width="100%"
                max-height="500px"
              />
            </v-col> -->
            <v-col
              cols="12"
              md="8"
              class="white--text text-center text-md-left"
            >
              <h3 class="font-weight-bold text-title">
                OSD, La Herramienta que tu Taller Necesita
              </h3>
              <div class="video-thumbnail" @click="openVideo">
                <img
                  src="../assets/img/miniaturas/min1.jpg"
                  alt="Video Thumbnail"
                  class="thumbnail"
                />
                <div class="play-icon d-flex align-center py-4">
                  <a @click.stop="dialog = true" class="playBut">
                    <svg
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      xmlns:a="http://ns.adobe.com/AdobeSVGViewerExtensions/3.0/"
                      x="0px"
                      y="0px"
                      width="60px"
                      height="60px"
                      viewBox="0 0 213.7 213.7"
                      enable-background="new 0 0 213.7 213.7"
                      xml:space="preserve"
                    >
                      <polygon
                        class="triangle"
                        fill="none"
                        stroke-width="7"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-miterlimit="10"
                        points="73.5,62.5 148.5,105.8 73.5,149.1 "
                      />
                      <circle
                        class="circle"
                        fill="none"
                        stroke-width="7"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-miterlimit="10"
                        cx="106.8"
                        cy="106.8"
                        r="103.3"
                      />
                    </svg>
                  </a>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
    <v-dialog
      v-model="dialog"
      max-width="75%"
      transition="dialog-bottom-transition"
    >
      <div
        style="
          position: relative;
          padding-bottom: 56.25%;
          height: 0;
          overflow: hidden;
          width: 100%;
        "
      >
        <iframe
          v-if="dialog"
          :src="`https://www.youtube.com/embed/${videoId}?autoplay=1`"
          frameborder="0"
          allow="autoplay; encrypted-media"
          allowfullscreen
          style="position: absolute; top: 0; left: 0; width: 100%; height: 100%"
        ></iframe>
      </div>
    </v-dialog>
  </section>
</template>

<script>
export default {
  name: "OSDBenefits",
  data() {
    return {
      dialog: false,
      videoId: "C_HxcwDBqvY", // ID del video de YouTube
    };
  },
  methods: {
    openVideo() {
      this.dialog = true; // Abre el modal
    },
  },
};
</script>

<style scoped>
#osd-benefits {
  background-attachment: fixed;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  min-height: 300px;
  width: 82%;
  background-color: transparent;
  margin: 0 auto; /* Esto centra el contenedor horizontalmente */

  /* Añadido para centrar el contenido de #osd-benefits */
  display: flex;
  justify-content: center;
  align-items: center;
}

#osd-benefits .container,
#osd-benefits .row {
  height: 100%;
}

.video-thumbnail {
  position: relative;
  cursor: pointer;
  display: inline-block;
  border-radius: 5%;
}

.thumbnail {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 8px;
  transition: transform 0.3s ease;
}

.text-title {
  color: #9abe23; /* Azul primario */
  font-size: 1.5rem;
}

ul {
  margin: 0;
  padding-left: 1.5rem;
}
p {
  color: white;
  font-size: 1.1rem;
  text-align: justify;
}

@media (max-width: 768px) {
  #osd-benefits h1 {
    font-size: 1.8rem;
  }

  #osd-benefits ul {
    padding-left: 1rem;
  }

  .text-title {
    font-size: 1.3rem;
  }
}
</style>
